export const LOG_LEVELS = {
  DEBUG: 'DEBUG',
  WARN: 'WARN',
  ERROR: 'ERROR',
};

export type LogLevel = typeof LOG_LEVELS[keyof typeof LOG_LEVELS];
